<template>
  <section class="py-5">
    <div class="container">
      <div class="d-flex align-items-start">
        <AccountOpes/>
        <div class="aiz-user-panel">
          <div class="aiz-titlebar mt-2 mb-4">
            <div class="row align-items-center">
              <div class="col-md-6">
                <h1 class="h3">{{ $t("我的钱包") }}</h1>
              </div>
            </div>
          </div>
          <div class="row gutters-10">
            <div class="col-md-3 mx-auto mb-3">
              <div v-if="paramMapAll['PACK_OPEN'] === '1'" class="bg-grad-1 text-white rounded-lg overflow-hidden">
                <div class="px-3 pt-2 pb-2">
                  <div class="h5 fw-700 text-center">
                    {{ formatMoney(userMoney.balance, currency, true) }}
                  </div>
                  <div class="opacity-50 text-center pb-2">{{ $t("钱包余额") }}</div>
                  <div class="h5 fw-700 text-center">
                    {{ formatMoney(userMoney.balance2, currency, true) }}
                  </div>
                  <div class="opacity-50 text-center">{{ $t("佣金余额") }}</div>
                </div>
              </div>
<!--              只有一个余额-->
              <div v-else class="bg-grad-1 text-white rounded-lg overflow-hidden">
                <span
                    class="size-30px rounded-circle mx-auto bg-soft-primary d-flex align-items-center justify-content-center mt-3"
                >
                  <i class="las la-dollar-sign la-2x text-white"></i>
                </span>
                <div class="px-3 pt-3 pb-3">
                  <div class="h4 fw-700 text-center">
                    {{ formatMoney(userMoney.balance, currency, true) }}
                  </div>
                  <div class="opacity-50 text-center">{{ $t("钱包余额") }}</div>
                </div>
              </div>
            </div>
            <div v-if="paramMapAll['SYSTEM_VERSION'] !== 'D06'" class="col-md-3 mx-auto mb-3">
              <div
                  class="p-3 rounded c-pointer text-center bg-white shadow-sm hov-shadow-lg has-transition"
                  @click="showWalletModal"
              >
                <span
                    class="size-60px rounded-circle mx-auto bg-secondary d-flex align-items-center justify-content-center mb-3"
                >
                  <i class="las la-plus la-3x text-white"></i>
                </span>
                <div class="fs-18 text-primary">{{ $t("充值钱包") }}</div>
              </div>
            </div>
            <div class="col-md-3 mx-auto mb-3">
              <div
                  class="p-3 rounded c-pointer text-center bg-white shadow-sm hov-shadow-lg has-transition"
                  @click="showRechargeModal"
              >
                <span
                    class="size-60px rounded-circle mx-auto bg-secondary d-flex align-items-center justify-content-center mb-3"
                >
                  <i class="las la-plus la-3x text-white"></i>
                </span>
                <div class="fs-18 text-primary">{{ this.paramMapAll['SYSTEM_VERSION'] !== 'D06' ? $t("钱包充值_线下_"):$t("充值钱包") }}</div>
              </div>
            </div>

            <div class="col-md-3 mb-3 mx-auto">
              <div
                  class="bg-grad-2 p-3 rounded c-pointer text-center bg-white shadow-sm hov-shadow-lg has-transition"
                  @click="showWithdrawModal"
              >
                <span
                    class="size-60px rounded-circle mx-auto bg-secondary d-flex align-items-center justify-content-center mb-3"
                >
                  <i class="las la-plus la-3x text-white"></i>
                </span>
                <div class="fs-18 text-white">{{ $t("申请提款") }}</div>
              </div>
            </div>

            <div v-if="paramMapAll['COMMISSION_CONVERT_OPEN'] === '1'" class="col-md-3 mb-3 mx-auto">
              <div
                  class="bg-grad-3 p-3 rounded c-pointer text-center bg-white shadow-sm hov-shadow-lg has-transition"
                  @click="showCommissionConvertModal"
              >
                <span
                    class="size-60px rounded-circle mx-auto bg-secondary d-flex align-items-center justify-content-center mb-3"
                >
                  <i class="las la-exchange-alt la-3x text-white"></i>
                </span>
                <div class="fs-18 text-white">{{ $t("佣金转余额") }}</div>
              </div>
            </div>
          </div>

          <van-tabs>
            <van-tab :title="$t('钱包收支明细')">
              <WalletRecordList/>
            </van-tab>
            <van-tab :title="$t('提现历史记录')">
              <WithdrawalRecordList/>
            </van-tab>
          </van-tabs>
        </div>
      </div>
    </div>
    <WalletRechargeModal
        ref="rechargeModal"
        :offline="false"
        :title="$t('钱包充值')"
    />
    <WalletRechargeModal
        ref="rechargeOfflineModal"
        :offline="true"
        :title="$t('钱包充值_线下_')"
    />
    <WithdrawModal ref="withdrawModal"/>
    <CommissionConvertModal ref="commissionConvertModal"/>
  </section>
</template>
<script>
import AccountOpes from "@/components/AccountOpes.vue";
import CommissionConvertModal from "@/components/CommissionConvertModal.vue";
import WalletRechargeModal from "@/components/WalletRechargeModal.vue";
import WalletRecordList from "@/components/WalletRecordList.vue";
import WithdrawalRecordList from "@/components/WithdrawalRecordList.vue";
import WithdrawModal from "@/components/WithdrawModal.vue";
import store from "@/store";

export default {
  async beforeRouteEnter(to, from, next) {
    console.log('userMoneyStore beforeRouteEnter')
    await store.dispatch('common/dictListComputeIfAbsentEnum', 'EnumWithdrawStatus')
    await store.dispatch('common/dictListComputeIfAbsentEnum', 'EnumTradeTypeStore')
    // await store.dispatch('common/dictListComputeIfAbsentEnum', 'EnumGoodsOrderShippingState')
    // await store.dispatch('common/dictListComputeIfAbsentEnum', 'EnumGoodsOrderPayState')
    // await store.dispatch('common/dictListComputeIfAbsentEnum', 'EnumRechargeState')
    next((vm) => {
      // access to component public instance via `vm`
    })
  },
  components: {
    WithdrawModal,
    WithdrawalRecordList,
    WalletRecordList,
    WalletRechargeModal,
    CommissionConvertModal,
    AccountOpes
  },
  // activated(){
  //   console.log('activated this.$route',this.$route)
  //   if (this.$route.query.option === 'withdraw') {
  //     this.$nextTick(() => {
  //       this.showWithdrawModal()
  //     });
  //   }
  // },
  watch: {
    '$route.query'() {
      if (this.$route.query.option === 'withdraw') {
        this.$nextTick(() => {
          this.showWithdrawModal()
        });
      }
      if (this.$route.query.option === 'recharge') {
        this.$nextTick(() => {
          this.showRechargeModal()
        });
      }
    },
    '$route'() {
      this.$store.dispatch("user/getUserMoney")
    },
  },
  created() {
    if (this.$route.query.option === 'withdraw') {
      this.$nextTick(() => {
        this.showWithdrawModal()
      });
    }
    if (this.$route.query.option === 'recharge') {
      this.$nextTick(() => {
        if (this.paramMapAll['SYSTEM_VERSION'] === 'E01') {
          this.showWalletModal()
        }else {
          this.showRechargeModal()
        }
      });
    }
  },
  methods: {
    showWalletModal() {
      let rechargeUrl = this.paramMapAll["RECHARGE_URL"];
      if (rechargeUrl) {
        window.open(rechargeUrl, "_blank")
      } else {
        this.$refs.rechargeModal.show();
      }
    },
    showRechargeModal() {
      let rechargeUrl = this.paramMapAll["RECHARGE_URL"];
      if (rechargeUrl) {
        window.open(rechargeUrl, "_blank")
      } else {
        this.$refs.rechargeOfflineModal.show();
      }
    },
    showWithdrawModal() {
      this.$refs.withdrawModal.show();
    },
    showCommissionConvertModal() {
      this.$refs.commissionConvertModal.show();
    }
  }
};
</script>
